import { WORDS_CREDIT, qurancomUrl } from '@iqrapath/shared'
import { Check } from 'lucide-react'
import { useState } from 'react'
import { SourceLink } from '../../components/SourceLink.tsx'
import { useLocalSet, type AyatDetail } from './ayat.ts'
import { CtaBar, NextStep } from './parts.tsx'
import { WordSheet, type WordItem } from './WordSheet.tsx'

/** Step 2: word by word. Opened words are remembered on this device ("x dari N"). */
export function Fahami({ d, day }: { d: AyatDetail; day: number }) {
  const a = d.ayat
  const [seen, markSeen] = useLocalSet(`iqp_kata_${day}`)
  const [open, setOpen] = useState<number | null>(null)

  const items: WordItem[] = (a.verses ?? []).flatMap((v) =>
    (v.kata ?? []).map((w, i, all) => ({ k: v.k, i, n: all.length, w, id: `${v.k}:${i}`, isKey: v.k === a.ayatFrom && i + 1 === a.kataKunci })),
  )
  const opened = items.filter((it) => seen.has(it.id)).length
  const show = (i: number) => { setOpen(i); markSeen(items[i]!.id) }

  return (
    <>
      <p className="step-hint">
        Sentuh satu kata untuk melihat artinya.{items.some((it) => it.isKey) && ' Titik amber menandai kata kunci hari ini.'}
      </p>

      {items.length > 0 ? (
        <>
          <div className="card words-progress">
            <div><span>Kata yang sudah kamu buka</span><b className="num">{opened} dari {items.length}</b></div>
            <div className="bar" aria-hidden="true"><i style={{ width: `${(opened / items.length) * 100}%` }} /></div>
          </div>
          {(a.verses ?? []).filter((v) => v.kata?.length).map((v) => (
            <section key={v.k} className="card words-card" aria-label={`Kata-kata ayat ${v.k}`}>
              <span className="pill pill-mint">Ayat {v.k}</span>
              <div className="words" dir="rtl">
                {items.map((it, idx) => it.k !== v.k ? null : (
                  <button key={it.id} type="button" className={`word${it.isKey ? ' key' : ''}${seen.has(it.id) ? ' seen' : ''}`} onClick={() => show(idx)}>
                    <span className="ar" lang="ar">{it.w.ar}</span>
                    <small dir="ltr">{it.w.arti ?? '…'}</small>
                    {it.isKey && <span className="sr">, kata kunci hari ini</span>}
                    {seen.has(it.id) && <Check className="seen-ic" size={12} aria-hidden="true" />}
                  </button>
                ))}
              </div>
            </section>
          ))}
          {items.some((it) => it.w.arti) && <p className="credit"><SourceLink href={qurancomUrl(a.surah, a.ayatFrom, a.ayatTo)}>{WORDS_CREDIT}</SourceLink></p>}
        </>
      ) : (
        <div className="card note-card">
          <p className="muted">Arti per kata untuk ayat ini belum tersedia. Kamu tetap bisa lanjut ke tahap berikutnya.</p>
        </div>
      )}

      {open !== null && <WordSheet surah={a.surah} items={items} at={open} onMove={show} onClose={() => setOpen(null)} note={a.catatanKata} />}

      <CtaBar><NextStep day={day} step="renungi" /></CtaBar>
    </>
  )
}
